var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5816 0 0 3.58174 0 8C0 12.4183 3.5816 16 8 16C12.4184 16 16 12.4183 16 8C16 3.58174 12.4184 0 8 0ZM7.98273 13.2523C7.39101 13.2523 6.90965 12.7709 6.90965 12.1792C6.90965 11.5875 7.39101 11.1061 7.98273 11.1061C8.57449 11.1061 9.05595 11.5874 9.05595 12.1792C9.05595 12.7709 8.57449 13.2523 7.98273 13.2523ZM9.66386 7.98395C9.20005 8.41788 8.89365 8.70452 8.89365 9.39863V9.91209C8.89365 10.042 8.78833 10.1474 8.65835 10.1474H7.38202C7.25205 10.1474 7.14673 10.042 7.14673 9.91209V9.39863C7.14673 7.97308 7.88762 7.27741 8.42857 6.76946C8.88904 6.33751 9.19318 6.05219 9.19318 5.36814C9.19318 5.15209 9.19318 4.49464 8.02024 4.49464C6.92047 4.49464 6.87642 5.10089 6.85765 5.35976L6.81939 5.88616C6.81473 5.94951 6.78475 6.00833 6.73605 6.04918C6.68753 6.09012 6.62442 6.10951 6.56122 6.1032L5.28824 5.97581C5.16118 5.96311 5.06748 5.85134 5.07704 5.724L5.11464 5.22457C5.22805 3.71991 6.37341 2.74767 8.03257 2.74767C8.90024 2.74767 9.63031 2.99125 10.1439 3.45205C10.6646 3.91939 10.94 4.58626 10.94 5.38052C10.9401 6.78894 10.2024 7.47962 9.66386 7.98395Z",
    fill: "#262A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.da0479b2f0f323d3eb35ff6327e1b123.svg";
export { ForwardRef as ReactComponent };